var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _circle0, _ellipse, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "335px",
    height: "206px",
    viewBox: "0 0 335 206",
    enableBackground: "new 0 0 335 206",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.6719,
    y1: 515.666,
    x2: 289.8281,
    y2: 515.666,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M297.256,55.678c1.996-1.324,4.16-2.525,6.537-2.818s5.014,0.494,6.369,2.468 c1.656,2.411,0.967,5.71-0.195,8.396c-2.652,6.14-7.422,11.259-13.105,14.787c-3.16,1.962-6.604,3.449-10.168,4.508 c-1.82,0.54-3.676,0.979-5.549,1.295c-2.172,0.366-2.941,0.561-2.758-1.786c0.523-6.674,5.533-14.076,9.803-18.929 C290.85,60.578,293.904,57.904,297.256,55.678z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 243.123,
    y1: 521.9648,
    x2: 261.5947,
    y2: 521.9648,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M264.305,87.721c-1.066-3.209-1.354-6.62-1.551-9.996c-0.311-5.339-0.414-10.714,0.277-16.018 c0.537-4.133,1.609-8.318,4.072-11.681c1.799-2.455,4.705-4.492,7.699-3.946c2.818,0.514,4.787,3.15,5.752,5.849 c1.92,5.364,0.973,11.303-0.371,16.84c-1.635,6.732-3.828,13.33-6.547,19.702c-0.906,2.127-2.143,7.485-4.615,6.466 C266.719,93.987,265.016,89.86,264.305,87.721z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 258.4424,
    y1: 536.1709,
    x2: 307.291,
    y2: 536.1709,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M302.789,81.413c4.016-0.696,8.168-1.12,12.139-0.205c3.488,0.804,7.09,3.167,7.479,6.726 c0.352,3.212-2.027,6.073-4.572,8.063c-5.984,4.675-13.676,6.891-21.27,6.944c-4.521,0.031-9.027-0.673-13.379-1.888 c-3.051-0.853-9.848-2.213-11.721-5.044c-2.967-4.488,14.986-10.238,18.143-11.284C293.912,83.298,298.322,82.188,302.789,81.413z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.9404,
    y1: 550.3906,
    x2: 247.4102,
    y2: 550.3906,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M245.719,118.764c-8.35-10.785-11.627-25.146-9.623-38.637c0.58-3.907,1.658-7.905,4.25-10.886 c2.594-2.979,7.035-4.641,10.635-3.018c3.025,1.363,4.742,4.59,5.789,7.737c3.727,11.209,1.652,23.429-0.65,35.015 c-0.469,2.359-0.945,4.717-1.426,7.072c-0.389,1.895-0.424,5.083-1.4,6.728C251.178,126.344,247.17,120.64,245.719,118.764z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.2236,
    y1: 565.1455,
    x2: 300.5967,
    y2: 565.1455,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M262.791,129.146c11.385,2.612,23.541,1.069,34.297-3.489c5.236-2.219,10.514-5.515,12.609-10.799 c0.629-1.584,0.934-3.377,0.385-4.99c-1.188-3.497-5.588-4.574-9.281-4.628c-12.041-0.174-23.527,4.639-34.602,9.366 c-3.797,1.62-11.152,3.698-13.502,7.346C250.082,126.017,260.127,128.536,262.791,129.146z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.2744,
    y1: 588.8281,
    x2: 235.8486,
    y2: 588.8281,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M215.361,138.033c-2.701-9.257-2.195-19.224,0.049-28.602c0.619-2.588,1.406-5.221,3.074-7.295 s4.412-3.481,7.002-2.866c1.469,0.349,2.729,1.292,3.82,2.336c2.289,2.188,4.049,4.927,5.09,7.918 c1.164,3.351,1.422,6.942,1.568,10.487c0.42,10.119,0.023,20.271-1.18,30.326c-0.283,2.372-0.246,5.406-1.072,7.652 c-0.869,2.361-1.963,1.525-3.902,0.273c-3.318-2.14-6.182-4.972-8.516-8.145C218.623,146.486,216.623,142.36,215.361,138.033z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.0186,
    y1: 600.3047,
    x2: 291.9102,
    y2: 600.3047,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M277.23,134.865c3.404-0.194,6.916-0.098,10.078,1.183s5.936,3.941,6.553,7.297 c0.543,2.947-0.646,6.021-2.586,8.307c-1.939,2.285-4.559,3.887-7.232,5.239c-13.09,6.617-28.664,8.128-42.984,5.362 c-2.391-0.463-7.17-1.155-7.879-4.133c-0.648-2.722,3.564-5.601,5.33-7.173c5.043-4.488,10.813-8.152,17-10.851 C262.371,137.104,269.754,135.294,277.23,134.865z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.9189,
    y1: 578.6426,
    x2: 299.6113,
    y2: 578.6426,
    gradientTransform: "matrix(0.9758 0.2189 -0.2189 0.9758 138.4204 -494.3912)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M295.186,95.232c3.539-0.38,7.078-1.005,10.516-1.935c2.963-0.801,6.389-1.68,8.77-3.702 c0.074-0.063,0.006-0.197-0.086-0.188c-2.76,0.296-5.43,1.524-8.111,2.232c-3.496,0.923-7.047,1.576-10.643,1.946 c-3.145,0.323-6.313,0.479-9.473,0.437c-4.135-0.056-7.561-0.992-11.307-2.517c8.123-10.91,16.809-21.381,26.029-31.308 c0.373-0.4-0.234-0.959-0.617-0.575c-9.357,9.344-18.338,18.472-26.465,28.981c-0.377,0.486-0.734,0.986-1.107,1.474 c-2.5-12.042-1.816-24.23,1.078-36.177c0.094-0.388-0.459-0.485-0.586-0.133c-4.402,12.138-4.631,25.385-1.697,37.913 c-6.871,9.089-13.318,18.499-19.279,28.207c-8.457-13.541-6.08-31.125-5.389-46.325c0.014-0.312-0.424-0.298-0.508-0.044 c-1.406,4.206-1.572,8.764-1.701,13.166c-0.131,4.473-0.17,8.977,0.1,13.444c0.449,7.469,2.063,15.2,6.535,21.355 c-6.467,10.664-12.35,21.654-17.629,32.929c-4.602-6.355-7.143-13.438-8.623-21.206c-1.736-9.122-2.594-18.999-1.135-28.229 c0.063-0.397-0.537-0.539-0.615-0.138c-3.338,16.834-1.449,37.476,9.539,51.406c-5.191,11.254-9.814,22.772-13.838,34.517 c-0.643,1.876,2.377,2.54,3.012,0.676c3.979-11.668,8.604-23.135,13.799-34.355c8.408,2,16.977,0.009,25.104-2.427 c8.83-2.646,16.609-6.311,24.223-11.443c0.201-0.136,0.008-0.444-0.203-0.319c-7.203,4.285-15.529,7.348-23.523,9.789 c-8.012,2.446-16.518,4.583-24.848,2.758c5.336-11.376,11.275-22.485,17.76-33.27c8.055,1.974,17.096,1.517,25.164,0.014 c8.453-1.575,17.297-4.621,24.238-9.823c0.428-0.322,0.031-0.934-0.443-0.697c-7.553,3.777-14.971,7.11-23.322,8.709 c-8.354,1.6-16.34,1.157-24.684,0.238c5.789-9.522,12.02-18.775,18.629-27.739C280.799,95.812,287.693,96.039,295.186,95.232z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 4349.2969,
    y1: -356.2822,
    x2: 4371.3047,
    y2: -356.2822,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_9_)",
    d: "M34.192,25.344c-1.558-1.14-3.258-2.186-5.168-2.514c-1.91-0.329-4.077,0.199-5.258,1.727 c-1.442,1.867-1.024,4.536-0.199,6.733c1.885,5.022,5.527,9.31,9.975,12.358c2.474,1.696,5.197,3.022,8.035,4.01 c1.449,0.504,2.932,0.929,4.434,1.254c1.742,0.378,2.355,0.565,2.307-1.323c-0.139-5.366-3.877-11.492-7.125-15.545 C39.168,29.521,36.81,27.259,34.192,25.344z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 4333.4531,
    y1: -351.2314,
    x2: 4348.4229,
    y2: -351.2314,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_10_)",
    d: "M59.49,52.302c0.998-2.529,1.375-5.25,1.678-7.947c0.479-4.264,0.791-8.566,0.457-12.84 c-0.26-3.332-0.949-6.726-2.799-9.517c-1.35-2.036-3.615-3.782-6.061-3.462c-2.303,0.301-4.006,2.336-4.902,4.459 c-1.781,4.222-1.268,9.015-0.414,13.503c1.035,5.457,2.529,10.827,4.459,16.039c0.643,1.738,1.414,6.078,3.459,5.359 C57.27,57.227,58.824,53.988,59.49,52.302z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 4345.8701,
    y1: -339.8433,
    x2: 4385.457,
    y2: -339.8433,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_11_)",
    d: "M28.622,45.741c-3.218-0.715-6.561-1.217-9.812-0.64c-2.856,0.507-5.87,2.259-6.336,5.094 c-0.42,2.559,1.382,4.943,3.358,6.637c4.643,3.979,10.771,6.056,16.912,6.396c3.658,0.203,7.333-0.185,10.905-0.987 c2.504-0.563,8.061-1.387,9.695-3.58c2.592-3.479-11.689-8.789-14.197-9.75C35.724,47.598,32.204,46.537,28.622,45.741z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 4315.4766,
    y1: -328.4424,
    x2: 4336.9287,
    y2: -328.4424,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_12_)",
    d: "M73.207,77.895c7.213-8.312,10.475-19.686,9.428-30.571c-0.305-3.152-1.006-6.397-2.977-8.885 s-5.494-3.993-8.477-2.834c-2.504,0.973-4.031,3.49-5.012,5.971c-3.49,8.832-2.332,18.701-0.961,28.072 c0.277,1.907,0.564,3.814,0.854,5.721c0.232,1.533,0.127,4.088,0.846,5.443C68.469,83.752,71.953,79.341,73.207,77.895z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 4335.9678,
    y1: -316.6123,
    x2: 4380.0322,
    y2: -316.6123,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_13_)",
    d: "M58.955,85.543c-9.324,1.646-19.092-0.066-27.601-4.14c-4.141-1.982-8.271-4.828-9.742-9.144 c-0.441-1.293-0.612-2.741-0.1-4.013c1.11-2.754,4.716-3.444,7.706-3.342c9.75,0.332,18.836,4.637,27.596,8.857 c3.002,1.446,8.865,3.399,10.611,6.413C69.369,83.533,61.135,85.158,58.955,85.543z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 4304.4014,
    y1: -297.627,
    x2: 4327.5596,
    y2: -297.627,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_14_)",
    d: "M96.949,94.52c2.576-7.309,2.592-15.313,1.176-22.912c-0.393-2.097-0.916-4.237-2.178-5.964 s-3.422-2.961-5.543-2.57c-1.203,0.223-2.262,0.929-3.189,1.722c-1.945,1.663-3.486,3.787-4.455,6.143 c-1.084,2.639-1.445,5.506-1.715,8.34c-0.77,8.088-0.881,16.235-0.334,24.337c0.129,1.911-0.031,4.34,0.543,6.172 c0.602,1.925,1.523,1.298,3.145,0.371c2.775-1.584,5.213-3.739,7.236-6.189C93.951,101.162,95.744,97.936,96.949,94.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 4326.8857,
    y1: -288.4248,
    x2: 4372.9922,
    y2: -288.4248,
    gradientTransform: "matrix(-0.9856 0.1692 0.1692 0.9856 4393.1499 -350.2976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_15_)",
    d: "M47.029,89.558c-2.746-0.29-5.592-0.35-8.203,0.552c-2.613,0.902-4.97,2.925-5.612,5.588 c-0.564,2.34,0.268,4.849,1.74,6.755c1.472,1.907,3.523,3.293,5.628,4.48c10.309,5.813,22.844,7.634,34.547,5.979 c1.955-0.276,5.85-0.645,6.551-3.002c0.641-2.154-2.646-4.626-4.008-5.954c-3.891-3.792-8.402-6.953-13.293-9.357 C58.957,91.933,53.059,90.194,47.029,89.558z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.1016,
    y1: 392.5762,
    x2: 95.957,
    y2: 392.5762,
    gradientTransform: "matrix(0.989 0.1477 -0.1477 0.989 62.6569 -317.0363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_16_)",
    d: "M34.188,57.108c-2.848-0.443-5.684-1.083-8.426-1.962c-2.362-0.758-5.097-1.596-6.938-3.309 c-0.058-0.053,0.004-0.158,0.078-0.146c2.22,0.344,4.328,1.434,6.468,2.105c2.788,0.877,5.633,1.538,8.527,1.976 c2.531,0.383,5.086,0.631,7.646,0.721c3.346,0.118,6.156-0.499,9.252-1.573c-6.105-9.056-12.689-17.783-19.728-26.097 c-0.284-0.335,0.231-0.758,0.525-0.437c7.173,7.852,14.05,15.514,20.179,24.252c0.283,0.403,0.553,0.818,0.834,1.223 c2.533-9.547,2.498-19.337,0.664-29.02c-0.061-0.314,0.391-0.37,0.48-0.083c3.045,9.895,2.666,20.514-0.238,30.435 c5.172,7.549,9.988,15.339,14.398,23.349c7.418-10.515,6.24-24.692,6.328-36.895c0.002-0.25,0.355-0.222,0.412-0.016 c0.959,3.424,0.9,7.082,0.816,10.612c-0.084,3.588-0.244,7.197-0.65,10.766c-0.682,5.965-2.314,12.095-6.195,16.85 c4.779,8.795,9.07,17.828,12.863,27.066c3.992-4.911,6.35-10.484,7.877-16.647c1.791-7.239,2.906-15.117,2.117-22.567 c-0.033-0.321,0.457-0.411,0.504-0.087c1.986,13.614-0.42,30.074-9.9,40.803c3.721,9.218,6.973,18.625,9.727,28.189 c0.441,1.527-2.029,1.941-2.465,0.424c-2.721-9.502-5.977-18.868-9.703-28.06c-6.889,1.272-13.734-0.658-20.207-2.928 c-7.029-2.466-13.17-5.705-19.109-10.114c-0.158-0.117,0.012-0.356,0.178-0.249c5.645,3.715,12.25,6.495,18.615,8.763 c6.377,2.273,13.168,4.318,19.984,3.184c-3.834-9.321-8.166-18.453-12.955-27.346c-6.6,1.266-13.895,0.545-20.357-0.975 c-6.773-1.593-13.798-4.379-19.192-8.817c-0.333-0.275,0.014-0.749,0.387-0.541c5.951,3.32,11.811,6.281,18.498,7.89 c6.691,1.607,13.17,1.566,19.961,1.157c-4.279-7.854-8.928-15.511-13.895-22.949C45.801,58.135,40.215,58.048,34.188,57.108z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.1348,
    y1: 910.792,
    x2: 157.0863,
    y2: 838.7753,
    gradientTransform: "matrix(0.9282 0.3722 -0.3722 0.9282 279.7938 -750.6688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_17_)",
    d: "M126.572,151.069l-69.029-27.679c-3.676-1.474-5.461-5.648-3.986-9.324l19.781-49.335l82.34,33.016 l-19.781,49.336C134.422,150.759,130.248,152.543,126.572,151.069z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.4316,
    y1: 862.5791,
    x2: 156.6144,
    y2: 818.2259,
    gradientTransform: "matrix(0.9282 0.3722 -0.3722 0.9282 279.7938 -750.6688)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_18_)",
    d: "M73.338,64.731l26.611,44.436c1.189,1.986,3.559,2.936,5.791,2.321l49.938-13.741L73.338,64.731z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.8447,
    y1: -609.9878,
    x2: 343.5255,
    y2: -650.9986,
    gradientTransform: "matrix(0.9372 -0.3488 0.3488 0.9372 34.0994 771.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_19_)",
    d: "M156.604,64.619l-34.064,12.678c-3.711,1.381-7.84-0.508-9.221-4.22l-9.521-25.583l47.506-17.68 l9.52,25.584C162.205,59.109,160.314,63.237,156.604,64.619z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.6445,
    y1: -637.3779,
    x2: 343.3203,
    y2: -662.7209,
    gradientTransform: "matrix(0.9372 -0.3488 0.3488 0.9372 34.0994 771.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEDF7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FAB94C"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_20_)",
    d: "M103.797,47.494l28.328,8.564c1.266,0.383,2.633-0.125,3.34-1.243l15.838-25.001L103.797,47.494z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.8398,
    y1: 99.2705,
    x2: 72.6183,
    y2: 127.036
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_21_)",
    d: "M122.799,122.197c-1.219-0.731-2.291-1.86-3.5-2.647c-3.711-2.413-7.779-4.273-11.914-5.827 c-5.07-1.905-10.314-3.332-15.613-4.436c-9.822-2.046-19.088-2.945-29.055-1.499c-7.551,1.096-15.061,2.73-22.27,5.253 c-5.923,2.072-12.487,4.716-17.186,9.052c-0.034,0.031-0.07,0.08-0.11,0.104c-15.57,9.342-9.342,24.911-9.342,24.911 l34.254-6.228c0-6.228-3.115-9.342-3.115-9.342c-6.227-6.229-3.113-9.342-3.113-9.342c5.516-2.758,11.852-3.663,17.953-3.857 c7.912-0.252,15.828-0.033,23.742,0.053c7.08,0.077,14.131,0.578,20.584,3.805c0,0,3.113,3.113-3.113,9.342 c0,0-3.115,3.114-3.115,9.342l34.254,6.228C132.141,147.108,138.369,131.539,122.799,122.197z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 3467.084,
    y1: 474.249,
    x2: 3467.4348,
    y2: 487.3732,
    gradientTransform: "matrix(-1.1756 -0.2155 -0.1803 0.9836 4277.8145 421.3771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_22_)",
    d: "M99.064,150.517l29.654,5.436c2.932,0.537,5.744-1.403,6.281-4.335l0.299-1.637 c0.537-2.931-1.402-5.743-4.334-6.28l-29.654-5.436c-2.932-0.537-5.744,1.404-6.281,4.335l-0.301,1.637 C94.191,147.168,96.133,149.979,99.064,150.517z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.873,
    y1: -193.5947,
    x2: 419.224,
    y2: -180.4686,
    gradientTransform: "matrix(1.1756 -0.2155 0.1803 0.9836 -427.9748 421.3771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_23_)",
    d: "M46.92,150.511l-29.721,5.447c-2.913,0.534-5.708-1.395-6.242-4.308l-0.312-1.702 c-0.534-2.913,1.395-5.708,4.308-6.242l29.72-5.447c2.914-0.533,5.709,1.396,6.242,4.309l0.313,1.702 C51.762,147.183,49.834,149.978,46.92,150.511z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.0195,
    y1: 144.96,
    x2: 74.514,
    y2: 200.8534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_24_)",
    d: "M91.76,115.969H82.98v9.342H75.6h-3.691h-7.381v-9.342h-8.779c-1.17,0-2.082,0.999-1.941,2.161 c0.846,7.072,1.158,29.835-26.833,43.183c-1.885,0.899-3.043,2.85-3.043,4.938l0,12.298c0,4.994,4.049,9.043,9.042,9.043h38.936 H75.6h38.936c4.994,0,9.043-4.049,9.043-9.043V166.25c0-2.088-1.16-4.038-3.045-4.938c-27.99-13.348-27.678-36.11-26.832-43.183 C93.842,116.968,92.932,115.969,91.76,115.969z"
  })), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 73.755,
    cy: 154.115,
    r: 17.905
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.876,
    y1: 149.6631,
    x2: 61.3491,
    y2: 155.9029
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_25_)",
    cx: 62.359,
    cy: 154.115,
    r: 3.256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.665,
    y1: 149.6631,
    x2: 84.1379,
    y2: 155.9033
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_26_)",
    cx: 85.148,
    cy: 154.115,
    r: 3.256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 2275.5059,
    y1: -1285.1973,
    x2: 2271.9792,
    y2: -1278.9578,
    gradientTransform: "matrix(0 -1 1 0 1354.5 2438.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_27_)",
    cx: 73.754,
    cy: 165.509,
    r: 3.255
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 2298.2959,
    y1: -1285.1978,
    x2: 2294.7688,
    y2: -1278.9575,
    gradientTransform: "matrix(0 -1 1 0 1354.5 2438.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_28_)",
    cx: 73.754,
    cy: 142.721,
    r: 3.255
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 892.7334,
    y1: -1037.9678,
    x2: 889.2067,
    y2: -1031.7283,
    gradientTransform: "matrix(0.6979 -0.7162 0.7162 0.6979 184.7236 1521.1404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_29_)",
    cx: 65.802,
    cy: 162.275,
    r: 3.256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 915.5215,
    y1: -1037.9668,
    x2: 911.9949,
    y2: -1031.7275,
    gradientTransform: "matrix(0.6979 -0.7162 0.7162 0.6979 184.7236 1521.1404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_30_)",
    cx: 81.706,
    cy: 145.955,
    r: 3.255
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 3463.1631,
    y1: -456.1084,
    x2: 3459.636,
    y2: -449.8681,
    gradientTransform: "matrix(-0.7162 -0.6979 0.6979 -0.7162 2875.6404 2253.7764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_31_)",
    cx: 81.914,
    cy: 162.068,
    r: 3.256
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 3485.9512,
    y1: -456.1069,
    x2: 3482.4246,
    y2: -449.8675,
    gradientTransform: "matrix(-0.7162 -0.6979 0.6979 -0.7162 2875.6404 2253.7764)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F1985F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3272,
    style: {
      stopColor: "#E6845A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7535,
    style: {
      stopColor: "#DB6E55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D76553"
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_32_)",
    cx: 65.594,
    cy: 146.163,
    r: 3.256
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.3174,
    y1: 129.792,
    x2: 187.959,
    y2: 141.777
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64449B"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_33_)",
    d: "M193.984,99.476c-7.174,0.599-11.08,8.246-13.375,14.904c-3.85,11.171-6.99,22.58-9.4,34.144 c-0.213,1.017-0.441,2.08-1.119,2.874c-1.066,1.25-2.916,1.48-4.584,1.601c-15.803,1.133-31.781,0.205-47.379-2.75 c-0.883,5.144-1.371,10.355-1.461,15.578c-0.014,0.812,0.002,1.688,0.498,2.345c0.482,0.639,1.305,0.919,2.078,1.157 c20.521,6.328,42.375,8.353,63.652,5.896c1.668-0.192,3.408-0.44,4.766-1.399c1.467-1.037,2.254-2.738,2.973-4.365 c6.77-15.329,12.947-30.912,18.518-46.706C212.383,113.583,206.063,98.468,193.984,99.476z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.4502,
    y1: 87.8662,
    x2: 293.3218,
    y2: 27.0147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32307D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C68A3"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_34_)",
    d: "M236.295,29.794c9.59,10.274,7.025,27.013,13.668,39.397c5.094,9.494,15.227,15.683,19.604,25.526 c5.246,11.797,0.32,26.588-9.768,34.646c-10.088,8.057-24.189,9.918-36.768,7.012c-5.791-1.338-11.43-3.646-16.1-7.323 c-10.063-7.928-14.441-21.265-15.178-34.055c-0.734-12.79,1.621-25.534,2.422-38.32c0.387-6.157,0.43-12.435,2.332-18.304 C202.125,21.039,223.682,16.282,236.295,29.794z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.582,
    y1: 203.9775,
    x2: 238.778,
    y2: 136.8067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64449B"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_35_)",
    d: "M268.111,186.287c-0.582,2.962-3.359,4.976-6.045,6.35c-8.334,4.243-17.826-0.702-27.168,0.03 c-25.979,2.046-31.916,2.439-57.77-1.07c-15.477-2.076-1.895-16.271,1.555-23.597c5.434-11.6,6.209-26.39,6.422-39.21 c0.154-8.7,1.68-20.151,4.178-26.35c1.307-3.248,9.93-6.082,10.602-6.173c6.809-1.19,13.736-1.832,20.637-1.893 c2.441-0.031,4.945,0.061,7.447,0.335c0.305,0.031,0.58,0.062,0.885,0.122c7.145,0.855,14.012,3.297,18.225,8.914 c2.717,3.633,3.938,8.181,5.098,12.576c5.129,19.567,10.256,45.239,15.385,64.807C268.02,182.808,268.477,184.578,268.111,186.287z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.416,
    y1: 92.7256,
    x2: 212.416,
    y2: 131.1645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F49673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_36_)",
    d: "M227.969,94.71c-2.502-0.274-5.006-0.366-7.447-0.335c-0.273,0.002-0.547,0.02-0.818,0.024 c0.277-10.033,0.762-20.063,1.604-30.084c-5.344-0.149-10.74,0.356-15.742,1.475c-4.908,1.098-5.723,2.151-5.334,4.871 c0.498,3.471,0.314,7.026,0.367,10.508c0.016,1.108-0.287,9.33-0.428,15.055c-0.094,0.016-0.189,0.027-0.285,0.044 c-1.037,3.449-1.189,9.065-1.586,11.355c-0.459,2.655-0.887,5.28-1.283,7.937c-0.152,1.038-0.305,6.898-1.037,7.326 c12.516-7.326,23.719-16.881,32.875-28.054C228.549,94.771,228.273,94.741,227.969,94.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.0195,
    y1: 65.1523,
    x2: 239.1934,
    y2: 65.1523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F49673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_37_)",
    d: "M230.834,59.569c2.578,3.152,2.188,8.218-0.633,11.154c-2.822,2.937-7.619,3.6-11.281,1.82 c-0.287-0.14-0.58-0.304-0.744-0.576c-0.139-0.229-0.168-0.507-0.193-0.774c-0.313-3.403-1.705-10.331,1.289-12.898 C222.311,55.689,228.453,56.658,230.834,59.569z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 203.1729,
    y1: 54.7393,
    x2: 203.4887,
    y2: 100.2192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F49673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_38_)",
    d: "M198.221,32.326c-5.773,1.23-10.896,4.334-13.867,10.225c-2.035,4.032-2.504,8.655-2.719,13.166 c-0.414,8.703,0.076,17.772,4.105,25.497c1.318,2.527,3.041,4.908,5.375,6.543c3.4,2.379,7.768,2.951,11.908,2.709 c13.467-0.785,19.602-11.483,21.135-23.909c0.98-7.946,1.426-19.303-1.826-26.796C218.457,30.83,206.406,30.581,198.221,32.326z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M189.291,58.908c-2.197,0-2.201,3.415,0,3.415C191.488,62.323,191.492,58.908,189.291,58.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M206.451,58.879c-2.234,0-2.238,3.474,0,3.474C208.688,62.353,208.691,58.879,206.451,58.879z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M193.096,56.804c-0.813-1.909-2.266-2.646-4.291-2.368c-1.396,0.191-3.092,1.039-3.418,2.529 c-0.027,0.122,0.111,0.264,0.232,0.178c0.906-0.643,1.578-1.438,2.709-1.737c1.838-0.485,3.244,0.126,4.018,1.837 C192.576,57.755,193.309,57.309,193.096,56.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M210.781,56.804c-0.811-1.909-2.266-2.646-4.289-2.368c-1.396,0.191-3.094,1.039-3.42,2.529 c-0.025,0.122,0.111,0.264,0.232,0.178c0.906-0.643,1.58-1.438,2.709-1.737c1.838-0.485,3.246,0.126,4.018,1.837 C210.264,57.755,210.996,57.309,210.781,56.804z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M201.291,68.736c-1.021,0.115-2.344,0.321-3.33-0.041c-0.814-0.3-0.689-0.365-0.617-1.257 c0.047-0.581,0.172-1.178,0.256-1.754c0.279-1.9,0.617-3.805,0.779-5.72c0.031-0.381-0.59-0.464-0.67-0.091 c-0.346,1.613-0.547,3.261-0.793,4.893c-0.135,0.892-0.887,3.097-0.518,3.988c0.582,1.403,3.773,0.962,4.893,0.836 C201.83,69.529,201.836,68.675,201.291,68.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#211D54",
    d: "M203.078,73.265c-0.873,2.193-3.174,2.928-5.346,2.715c-2.035-0.2-3.389-1.271-4.221-3.11 c-0.092-0.203-0.453-0.107-0.428,0.115c0.584,5.287,9.184,5.018,10.752,0.489C204.004,72.988,203.262,72.806,203.078,73.265z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.6162,
    y1: 53.1777,
    x2: 222.1567,
    y2: -3.1616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32307D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C68A3"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_39_)",
    d: "M228.396,49.13c-0.611,0.544-1.281,1.021-2.025,1.422c-0.619,0.334-1.254,0.603-1.906,0.812 c-4.141,1.363-8.883,0.477-13.207-0.636c-2.936-0.753-6.33-2.066-7.033-5.018c-4.676,2.618-9.719,4.583-14.93,5.821 c-7.912,1.882-16.242-0.552-16.35-9.986c-0.127-11.592,8.104-16.828,18.023-19.044c6.982-1.564,15.488-2.843,23.133-1.605 c2.912,0.477,5.705,1.313,8.23,2.651c3.178,1.664,5.947,4.106,8.045,7.577C233.781,36.735,233.129,44.915,228.396,49.13z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.8301,
    y1: 204.2354,
    x2: 254.1947,
    y2: 84.034
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BA3D6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#64449B"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_40_)",
    d: "M229.588,102.375c-6.703,2.157-8.785,10.476-9.545,17.476c-1.273,11.742-1.822,23.563-1.643,35.373 c0.016,1.038,0.027,2.126-0.449,3.049c-0.748,1.455-2.459,2.085-4.021,2.567c-14.803,4.572-30.211,7.172-45.693,7.71 c0.262,5.211,0.912,10.403,1.943,15.519c0.162,0.795,0.363,1.646,0.977,2.179c0.596,0.518,1.439,0.61,2.227,0.673 c20.889,1.674,42.127-1.145,61.857-8.208c1.547-0.554,3.15-1.178,4.236-2.411c1.176-1.333,1.561-3.166,1.896-4.911 c3.164-16.439,5.711-32.999,7.633-49.63C250.121,112.103,240.869,98.742,229.588,102.375z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.9297,
    y1: 66.9004,
    x2: 225.7852,
    y2: 66.9004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_41_)",
    d: "M224.848,58.023c-0.365,8.396-1.965,17.599-11.529,16.855c-0.527-0.041-0.508,0.751,0,0.811 c9.666,1.133,12.18-8.778,12.467-17.593C225.465,58.098,225.152,58.072,224.848,58.023z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.1309,
    y1: 75.1133,
    x2: 214.4102,
    y2: 75.1133
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32307D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C68A3"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_42_)",
    d: "M212.596,77.206h-2.652c-0.996,0-1.813-0.816-1.813-1.813v-0.56c0-0.997,0.816-1.813,1.813-1.813 h2.652c0.998,0,1.814,0.816,1.814,1.813v0.56C214.41,76.39,213.594,77.206,212.596,77.206z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.8652,
    y1: 27.5547,
    x2: 223.3743,
    y2: 48.1847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F49673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_43_)",
    d: "M228.396,49.13c-0.277,6.298-1.146,11.124-1.146,11.124h-3.764 c0.494-3.212,0.811-6.164,0.979-8.891c1.33-21.879-7.076-28.663-10.363-30.469c2.912,0.477,5.705,1.313,8.23,2.651 C228.053,28.957,228.789,40.44,228.396,49.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.2051,
    y1: 61.8652,
    x2: 210.6176,
    y2: 70.6469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32307D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C68A3"
    }
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_44_)",
    cx: 224.322,
    cy: 63.39,
    r: 7.945
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.75,
    y1: 56.9512,
    x2: 221.2711,
    y2: 71.0301
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCD1BE"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_45_)",
    cx: 226.414,
    cy: 63.39,
    rx: 7.527,
    ry: 7.946
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.5723,
    y1: 134.7764,
    x2: 122.5659,
    y2: 192.847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33437D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    style: {
      stopColor: "#4A5A97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    style: {
      stopColor: "#6073B7"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_46_)",
    d: "M193.389,182.494l-16.834-47.007c-0.529-1.477-1.928-2.461-3.496-2.461H97.035 c-2.57,0-4.363,2.546-3.496,4.965l17.801,49.71h7.758h76.154h21.48v-5.207H193.389z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.8aead8d7be9a18b5d2506181e1e3b9d9.svg";
export { ForwardRef as ReactComponent };